module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("mrfclip")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "channel"
  }, [_c('poly-canvas'), _vm._v(" "), _c('user-inputs')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("A polygon clipping library for Tcl \n        "), _c('a', {
    attrs: {
      "href": "https://github.com/shages/mrfclip",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "github-link",
    attrs: {
      "src": require("./assets/GitHub-Mark-32px.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c8bb9d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 55
// module chunks = 0